export const API_BASE = "api/v1/budget-params";

// Admin panel'ning yagona ishlaydigan interfeys tili — hozircha til almashtirgich
// yo'q (StateBudgetList.vue'dagi HL_HEADER konvensiyasiga mos).
export const HL_HEADER = {hl: "uz_lat"};

export const LANG_TABS = [
  {code: "uz_lat", tabLabel: "UZ"},
  {code: "uz_cyr", tabLabel: "UZ Krill"},
  {code: "ru", tabLabel: "RU"},
  {code: "en", tabLabel: "EN"},
  {code: "kr", tabLabel: "KR"},
];

export const TITLE_LANG_LABELS = {
  uz_lat: "O'zbekcha (lotin)",
  uz_cyr: "Ўзбекча (кирилл)",
  ru: "Русский",
  en: "English",
  kr: "Qoraqalpoqcha",
};
